var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicRoomsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 25.957 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_578",
    "data-name": "\\u7EC4 578",
    transform: "translate(-2135.715 -1700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_577",
    "data-name": "\\u7EC4 577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_256",
    "data-name": "\\u8DEF\\u5F84 256",
    d: "M2142.2,1726q.293-1.917.584-3.833.517-3.37,1.038-6.739.464-3.019.927-6.038a1.327,1.327,0,0,1,.038-.139h7.815c.081.52.163,1.044.244,1.567q.544,3.532,1.087,7.065t1.092,7.089c.053.343.1.685.152,1.028Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_257",
    "data-name": "\\u8DEF\\u5F84 257",
    d: "M2135.715,1722.6a5.213,5.213,0,0,1,.184-.546,2.223,2.223,0,0,1,2.009-1.39c.214-.012.43,0,.653-.022a2.411,2.411,0,0,1-1.629-1.338,2.2,2.2,0,0,1-.127-1.51,2.278,2.278,0,0,1,4.459.249c.2,1.145-.433,2.034-1.9,2.62.3,0,.541-.013.778,0a2.617,2.617,0,0,1,.569.1c.675.206.71.284.6.974-.214,1.343-.417,2.688-.623,4.033a1.874,1.874,0,0,0-.008.226h-4.41a1.169,1.169,0,0,1-.558-.559Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_258",
    "data-name": "\\u8DEF\\u5F84 258",
    d: "M2156.7,1726c-.092-.652-.179-1.3-.277-1.955q-.2-1.367-.426-2.73c-.023-.148.008-.258.148-.306a10.219,10.219,0,0,1,1.073-.338,5.779,5.779,0,0,1,.707-.03,2.4,2.4,0,0,1-1.649-1.383,2.195,2.195,0,0,1-.1-1.488,2.278,2.278,0,0,1,4.458.294c.183,1.131-.45,2.018-1.9,2.6.294,0,.523-.007.752,0a2.267,2.267,0,0,1,2.181,2.209c.016.778,0,1.556,0,2.335a.86.86,0,0,1-.558.794Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_259",
    "data-name": "\\u8DEF\\u5F84 259",
    d: "M2149,1700c.089.024.177.049.266.072a2.285,2.285,0,0,1,.059,4.406,1.14,1.14,0,0,0-.224.079,2.691,2.691,0,0,1,2.3.763,2.959,2.959,0,0,1,.577,2.374h-6.532a2.489,2.489,0,0,1,2.849-3.147,2.358,2.358,0,0,1-1.383-.846,2.285,2.285,0,0,1,1.266-3.64c.073-.018.144-.041.217-.061Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_260",
    "data-name": "\\u8DEF\\u5F84 260",
    d: "M2141.084,1709.141c.278.016.537.022.795.047a2.062,2.062,0,0,1,1.146.491.283.283,0,0,1,.107.2c-.228,1.538-.465,3.074-.7,4.629-.092.006-.173.015-.254.015h-4a.782.782,0,0,1-.885-.888q0-1.029,0-2.057a2.293,2.293,0,0,1,2.391-2.422,2.431,2.431,0,0,0,.385-.023,2.459,2.459,0,0,1-1.433-1.082,2.206,2.206,0,0,1-.244-1.782,2.278,2.278,0,0,1,4.422.114C2143.059,1707.578,2142.526,1708.437,2141.084,1709.141Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_261",
    "data-name": "\\u8DEF\\u5F84 261",
    d: "M2156.333,1709.158c-1.493-.726-2.046-1.653-1.736-2.847a2.28,2.28,0,0,1,4.472.283,2.4,2.4,0,0,1-1.74,2.564h.328a2.3,2.3,0,0,1,2.441,2.447q0,1.041,0,2.082a.765.765,0,0,1-.833.837q-2.053,0-4.1,0c-.059,0-.117-.006-.2-.011q-.105-.675-.21-1.348c-.164-1.069-.331-2.138-.483-3.209a.382.382,0,0,1,.114-.292,2.272,2.272,0,0,1,1.528-.507Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicRoomsFilled);
export default __webpack_public_path__ + "static/media/public_rooms_filled.efb58f42eb6162b7239ce42fa3573ee8.svg";
export { ForwardRef as ReactComponent };